"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppCheckManager = void 0;
const app_check_1 = require("firebase/app-check");
function isCapacitorNativeShell() {
    if (typeof window === 'undefined')
        return false;
    const Cap = window.Capacitor;
    if (Cap && typeof Cap.isNativePlatform === 'function') {
        try {
            return Cap.isNativePlatform();
        }
        catch (_a) {
            return false;
        }
    }
    return false;
}
/**
 * App Check Manager
 * Handles Firebase App Check initialization across platforms
 */
class AppCheckManager {
    constructor() {
        this.appCheck = null;
    }
    /**
     * Initialize Firebase App Check
     */
    initialize(app) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.appCheck) {
                console.log('♻️ AppCheckManager: Already initialized');
                return this.appCheck;
            }
            try {
                console.log('🛡️ AppCheckManager: Initializing App Check...');
                const nativeShell = isCapacitorNativeShell();
                if (!nativeShell) {
                    // Browser (desktop or mobile) — reCAPTCHA v3; key must be in packages/web/.env*
                    const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
                    if (!siteKey) {
                        console.warn('⚠️ AppCheckManager: reCAPTCHA site key not found. App Check disabled for web.');
                        console.warn('⚠️ Set REACT_APP_RECAPTCHA_SITE_KEY in packages/web/.env.local and restart the dev server.');
                        return null;
                    }
                    this.appCheck = (0, app_check_1.initializeAppCheck)(app, {
                        provider: new app_check_1.ReCaptchaV3Provider(siteKey),
                        isTokenAutoRefreshEnabled: true
                    });
                    console.log('✅ AppCheckManager: Initialized with reCAPTCHA v3 for web');
                }
                else {
                    // Capacitor shell — device attestation via native layer
                    // The native SDKs (@capacitor-firebase/app-check) handle this automatically
                    this.appCheck = (0, app_check_1.initializeAppCheck)(app, {
                        provider: new app_check_1.CustomProvider({
                            getToken: () => {
                                // This will be handled by the native SDK
                                // iOS: App Attest
                                // Android: Play Integrity
                                return Promise.resolve({ token: '', expireTimeMillis: 0 });
                            }
                        }),
                        isTokenAutoRefreshEnabled: true
                    });
                    console.log('✅ AppCheckManager: Initialized for native platform (iOS/Android)');
                }
                return this.appCheck;
            }
            catch (error) {
                console.error('❌ AppCheckManager: Initialization failed:', error);
                // Don't throw - allow app to work without App Check in development
                return null;
            }
        });
    }
    /**
     * Get the App Check instance
     */
    getInstance() {
        return this.appCheck;
    }
}
exports.AppCheckManager = AppCheckManager;
